import React from 'react'
import SVG from 'react-inlinesvg'
import { Button } from '@bhvr/web-design-system'

import useModalBox from '../../utils/hooks/useModalBox'
import fileDownload from '../../utils/helpers/file-download'
import trackLink from '../../utils/helpers/tracking/track-link'
import AnchorLink from './anchor-link'
import Link from './link'
import external from '../../assets/icons/external-link.svg'
import download from '../../assets/icons/download.svg'

const CustomButton = (props) => {
  return (
    props.trigger && props.trigger === 'internalLink' ? (
      <Link
        id={props.id}
        key={props.link}
        to={props.link}
        trackClick={props}
        className={props.overwrite ? props.className : `button ${props.style ? `button-${props.style}` : ''} relative z-10 inline-flex w-full items-center justify-center md:w-auto ${props.size ? props.size : ''} ${props.className ? props.className : ''}`}
      >
        {props.children ? props.children : (<span>{props.label}</span>)}
      </Link>
    ) : (
      props.trigger && (props.trigger === 'anchor' || props.trigger === 'anchorLink') ? (
        <AnchorLink
          to={props.link}
          ariaLabel={`Scroll to ${props.label ? props.label : props.to}`}
          dataLink={props.anchor}
          trackClick={props}
          className={props.overwrite ? props.className : `button ${props.style ? `button-${props.style}` : ''} relative z-10 inline-flex w-full items-center justify-center cursor-pointer md:w-auto ${props.size ? props.size : ''} ${props.className ? props.className : ''}`}
        >
          {props.children ? props.children : (<span>{props.label}</span>)}
        </AnchorLink>
      ) : (
        <ButtonWrapper props={props} />
      )
    )
  )
}

export default CustomButton

const ButtonWrapper = ({ props }) => {
  const [modal, openModalBox] = useModalBox()
  function setModalBoxContent(tracking, type, className, data) {
    if (tracking) {
      trackLink(data)
    }
    openModalBox(type, className, data)
  }

  const buttonAction = (e) => {
    if (props.onClick || props.trigger === 'clickAction') {
      const clickAction = props.onClick
      clickAction()
      if (props.trackable) {
        trackLink(props)
      }
    } else if (props.trigger === 'download') {
      fileDownload(props.link, props.title)
    } else if (props.trigger === 'buyModal') {
      setModalBoxContent(true, 'buyGame', 'modal-buy relative h-full w-full lg:h-5/6 lg:w-5/6 overflow-hidden', props)
    } else if (props.trigger === 'videoModal') {
      setModalBoxContent(props.trackable, 'video', 'modal-video w-[90%] lg:w-3/4 z-90 relative', props)
    } else if (props.trigger === 'imageModal') {
      setModalBoxContent(false, 'image', 'modal-image z-90 relative', props)
    } else if (props.trigger === 'eventModal') {
      setModalBoxContent(true, 'eventReminder', 'modal-event relative h-full w-full lg:h-3/4 lg:w-3/4 overflow-hidden', props)
    } else if (props.trigger === 'listModal') {
      setModalBoxContent(true, 'list', 'modal-list relative overflow-hidden', props)
    } else if (props.trigger === 'dynamicModal') {
      setModalBoxContent(props.trackable, 'dynamic', 'modal-dynamic z-90 relative', props)
    } else if (props.trigger === 'externalLink') {
      trackLink(props)
    }

    // Send a GameSight Event on button click
    if (process.env.GATSBY_GAMESIGHT_ID && props.gsEvent && typeof tbhvr !== 'undefined' && typeof tbhvr === 'function') {
      tbhvr('send', props.gsEvent)
    }
  }

  const buttonClass = (props.trigger === 'externalLink' || props.trigger === 'download') ? 'button-external' : (props.trigger === 'videoModal' ? 'button-video' : '')

  return (
    <Button
      id={props.id}
      key={props.link}
      trigger={props.trigger}
      link={props.trigger !== 'videoModal' && props.trigger !== 'buyModal' && props.trigger !== 'eventModal' && props.trigger !== 'imageModal' && props.trigger !== 'listModal' && props.trigger !== 'download' ? props.link : null}
      label={props.label ? props.label : null}
      onClick={buttonAction}
      className={props.overwrite ? props.className : `button ${buttonClass} ${props.style ? `button-${props.style}` : ''} relative z-10 inline-flex w-full items-center justify-center md:w-auto ${props.size ? props.size : ''} ${props.className ? props.className : ''}`}
    >
      {props.children ? props.children : ''}
      {props.icon ? (
        // Custom Icon
        <SVG
          onError={(error) => console.log(error.message)}
          cacheRequests={true}
          preProcessor={(code) =>
            code.replace(/fill=".*?"/g, 'fill="currentColor"')
          }
          src={
            props.icon.localFile
              ? props.icon.localFile.publicURL
              : props.icon.url
                ? props.icon.url
                : props.icon.publicURL
          }
          className="button-icon"
        />
      ) : (
        <>
          {props.trigger === 'download' && (
            // Download Icon
            <SVG
              onError={(error) => console.log(error.message)}
              cacheRequests={true}
              preProcessor={(code) =>
                code.replace(/fill=".*?"/g, 'fill="currentColor"')
              }
              src={download}
              className="button-icon"
            />
          )}
          {props.trigger === 'externalLink' && props.externalIcon && (
            // External Link Icon
            <SVG
              onError={(error) => console.log(error.message)}
              cacheRequests={true}
              preProcessor={(code) =>
                code.replace(/fill=".*?"/g, 'fill="currentColor"')
              }
              src={external}
              className="button-icon externallink-indicator"
            />
          )}
        </>
      )}
    </Button>
  )
}